import { create } from 'zustand';

export const featuresDefaults = {
  destinations: false,
  malware_scanning: false,
  share_otp_guest_login: false,
  share_collaboration: false,
  asset_submission: false,
  // add other features here with their default values and use it by calling
  // useFeatureStore((state) => state.featureName) in the component/s
} as const;

export type Features = typeof featuresDefaults;

interface FeatureState extends Features {
  setFeature: <K extends keyof Features>(key: K, value: boolean) => void;
}

export const useFeatureStore = create<FeatureState>((set) => ({
  ...featuresDefaults,
  setFeature: <K extends keyof Features>(key: K, value: boolean) => set({ [key]: value }),
}));
